<template>
  <div
    :style="{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      paddingRight: '2px',
      paddingLeft: '2px',
      color: corTexto,
    }"
  >
    <div
      id="telaCarregamento"
      class="telaCarregamento"
      :class="{
        aberto: telaCarregamento === 'aberto',
        fechado: telaCarregamento === 'fechado',
      }"
    >
      <div
        class="spinner-border"
        style="width: 3.5rem; height: 3.5rem"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          text-align: center;
          align-items: center;
        "
      >
        <h1>Realizando seu pedido...</h1>
        <span>O processo do pedido pode demorar um pouco.</span>
      </div>
    </div>
    <button
      :style="{
        alignItems: 'center',
        marginTop: '5px',
        marginBottom: '5px',
        backgroundColor: corBotao,
        color: corTexto,
      }"
      class="btn btn-dark"
    >
      Opções de entrega
    </button>
    <br />
    <section>
      <div v-if="spinnerEndereco == false">
        <div
          style="display: -webkit-box; align-items: center"
          v-if="retirarBoolean && retirarLocalInis"
        >
          <input
            type="radio"
            id="retirarLocal"
            value="retirarLocal"
            v-model="endereco_cd"
            @click="
              taxaEndereco(0);
              retornar_cd_endereco(0);
            "
          />
          <label
            style="padding-left: 10px"
            for="retirarLocal"
            @click="
              taxaEndereco(0);
              retornar_cd_endereco(0);
            "
          >
            Retirar no Local</label
          >
        </div>
        <div
          style="display: -webkit-box; align-items: center"
          v-if="retirarBoolean && this.comerLocalHabilitado == 1"
        >
          <input
            type="radio"
            id="comerLocal"
            value="comerLocal"
            v-model="endereco_cd"
            @click="
              taxaEndereco(0);
              retornar_cd_endereco(0);
            "
          />
          <label
            style="padding-left: 10px"
            for="comerLocal"
            @click="
              taxaEndereco(0);
              retornar_cd_endereco(0);
            "
          >
            Comer no Local</label
          >
        </div>
        <div
          v-if="
            tipoEntrega === '3' &&
            tipoEntrega === '4' &&
            !somenteRetirada &&
            enderecos &&
            enderecos.length > 0
          "
        >
          <ul
            v-for="(endereco, idx) of enderecos.filter((e) =>
              possuiRaio &&
              (tipoEntrega === '2' ||
                tipoEntrega === '3' ||
                tipoEntrega === '4')
                ? e.cep !== null && e.cep !== ''
                : e.cep === null || e.cep === ''
            )"
            :key="idx"
          >
            <li>
              <div
                style="display: -webkit-box !important; align-items: center"
                @click="retornar_cd_endereco(endereco.cd)"
                :id="endereco.cd"
              >
                <input
                  v-if="endereco.taxa !== null"
                  type="radio"
                  :id="idx + 'endereco'"
                  :value="idx"
                  v-model="endereco_cd"
                  @click="validarEndereco(endereco.taxa, endereco.cd, endereco)"
                />
                <input
                  v-else
                  type="radio"
                  :id="idx + 'endereco'"
                  @click="enderecoFora(idx + 'endereco')"
                  class="disabled-radio"
                />
                <label
                  v-if="endereco.taxa !== null"
                  style="padding-left: 10px"
                  :for="idx + 'endereco'"
                  @click="validarEndereco(endereco.taxa, endereco.cd, endereco)"
                >
                  {{
                    [
                      endereco.bairro ? "Bairro: " + endereco.bairro : null,
                      endereco.rua ? "Rua: " + endereco.rua : null,
                      endereco.complemento
                        ? "Complemento: " + endereco.complemento
                        : null,
                      endereco.proximidade
                        ? "Ponto de referência: " + endereco.proximidade
                        : null,
                      endereco.cep ? "CEP: " + endereco.cep : null,
                      endereco.taxa
                        ? `Taxa: R$${parseFloat(endereco.taxa).toFixed(2)}`
                        : "Taxa: Fora de Alcance",
                    ]
                      .filter(Boolean)
                      .join(" | ")
                  }}
                </label>
                <label
                  v-else
                  style="padding-left: 10px"
                  :for="idx + 'endereco'"
                  @click="enderecoFora(idx + 'endereco')"
                >
                  {{
                    [
                      endereco.bairro ? "Bairro: " + endereco.bairro : null,
                      endereco.rua ? "Rua: " + endereco.rua : null,
                      endereco.complemento
                        ? "Complemento: " + endereco.complemento
                        : null,
                      endereco.proximidade
                        ? "Ponto de referência: " + endereco.proximidade
                        : null,
                      endereco.cep ? "CEP: " + endereco.cep : null,
                      endereco.taxa
                        ? `Taxa: R$${parseFloat(endereco.taxa).toFixed(2)}`
                        : "Taxa: Fora de Alcance",
                    ]
                      .filter(Boolean)
                      .join(" | ")
                  }}
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div v-else-if="!somenteRetirada && enderecos && enderecos.length > 0">
          <ul
            v-for="(endereco, idx) of enderecos.filter((e) =>
              possuiRaio && tipoEntrega === '2'
                ? e.cep !== null && e.cep !== ''
                : e.cep === null || e.cep === ''
            )"
            :key="idx"
          >
            <li>
              <div
                style="display: -webkit-box !important; align-items: center"
                @click="retornar_cd_endereco(endereco.cd)"
                :id="endereco.cd"
              >
                <input
                  type="radio"
                  :id="idx + 'endereco'"
                  :value="idx"
                  v-model="endereco_cd"
                  @click="
                    validarEndereco(
                      endereco.taxa,
                      endereco.cd,
                      endereco,
                      endereco.latitude,
                      endereco.longitude
                    )
                  "
                  :disabled="
                    possuiRaio &&
                    tipoEntrega === '2' &&
                    !endereco.entregaPorRaioDisponivel
                  "
                />
                <label
                  style="padding-left: 10px"
                  :for="idx + 'endereco'"
                  @click="existeCep(idx + 'endereco', endereco.cep)"
                >
                  {{
                    [
                      endereco.bairro ? "Bairro: " + endereco.bairro : null,
                      endereco.rua ? "Rua: " + endereco.rua : null,
                      endereco.complemento
                        ? "Complemento: " + endereco.complemento
                        : null,
                      endereco.proximidade
                        ? "Ponto de referência: " + endereco.proximidade
                        : null,
                      endereco.cep ? "CEP: " + endereco.cep : null,
                      `Taxa: R$${parseFloat(endereco.taxa).toFixed(2)}`,
                    ]
                      .filter(Boolean)
                      .join(" | ")
                  }}
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="spinner-border" role="status" v-else>
        <span class="sr-only">Loading...</span>
      </div>
    </section>
    <div style="display: flex; align-items: center; justify-content: flex-end">
      <button
        v-if="!somenteRetirada"
        style="
          align-items: center;
          margin-top: 5px;
          margin-bottom: 5px;
          margin-right: 5px;
          background-color: #006400;
        "
        class="btn btn-dark"
        @click="pushEnderecos()"
      >
        Cadastrar novo endereço
      </button>
    </div>
    <br />
    <div
      style="display: flex; justify-content: center; flex-direction: column"
      class="app"
    >
      <button
        :style="{
          alignItems: 'center',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto,
        }"
        class="btn btn-dark"
      >
        Forma de pagamento
      </button>
    </div>
    <br />

    <div class="radio-tabs">
      <input
        type="radio"
        name="payment"
        id="entrega"
        class="radio-input"
        checked
      />
      <label @click="trocarTipoPagamento('entrega')" class="radio-label"
        >Pagamento na Entrega/Retirada</label
      >

      <input
        v-if="
          (possuiAsaas || possuiMercadoPago) &&
          (pagamentoOnline === '1' || pagamentoOnline === '3')
        "
        type="radio"
        name="payment"
        id="site"
        class="radio-input"
      />
      <label
        v-if="
          (possuiAsaas || possuiMercadoPago) &&
          (pagamentoOnline === '1' || pagamentoOnline === '3')
        "
        @click="trocarTipoPagamento('site')"
        class="radio-label"
        >Pagamento pelo Site</label
      >
    </div>

    <section
      v-if="tipoPagamento === 'entrega'"
      style="display: flex; justify-content: space-between"
    >
      <div v-if="spinnerCartao == false">
        <ul style="display: flex; flex-direction: column">
          <li
            style="display: flex; align-items: center"
            v-for="bandeira of bandeiras"
            :key="bandeira.cd"
          >
            <input
              type="radio"
              :id="bandeira.cd"
              :value="bandeira.nm"
              v-model="pagamento"
            />
            <label style="padding-left: 10px" :for="bandeira.cd">{{
              bandeira.nm
            }}</label>
          </li>
        </ul>
        <div style="display: flex; align-items: center">
          <input
            type="radio"
            id="dinheiro"
            value="dinheiro"
            v-model="pagamento"
          />
          <label style="padding-left: 10px" for="dinheiro"> Dinheiro</label>
        </div>
        <div v-if="pagamento == 'dinheiro'">
          <label for="dinheiro">Troco para:</label>
          <div style="display: flex">
            <input
              style="width: 100px"
              type="number"
              inputmode="decimal"
              step=".01"
              id="valorDinheiro"
              value="valorDinheiro"
              v-model="valorDinheiro"
              class="form-control"
              placeholder="Troco para:"
            />
          </div>
        </div>
      </div>
      <div class="spinner-border" role="status" v-else>
        <span class="sr-only">Loading...</span>
      </div>

      <br />
      <div style="display: block">
        <input
          style="width: 120px"
          type="text"
          id="cupom"
          value="cupom"
          v-model="cupom"
          class="form-control"
          placeholder="cupom"
        />
        <button
          style="
            align-items: center;
            margin-top: 5px;
            background-color: #006400;
          "
          class="btn btn-dark"
          @click="verificaCupom(cupom)"
        >
          Ativar Cupom
        </button>
      </div>
    </section>

    <section
      v-else-if="tipoPagamento === 'site'"
      style="display: flex; justify-content: space-between"
    >
      <div v-if="spinnerCartao == false">
        <ul style="display: flex; flex-direction: column">
          <li style="display: flex; align-items: center" key="credito">
            <input
              type="radio"
              id="credito"
              value="credito-online"
              v-model="pagamento"
            />
            <label style="padding-left: 10px" for="credito"
              >Cartão de Crédito</label
            >
          </li>
          <li style="display: flex; align-items: center" key="pix">
            <input
              type="radio"
              id="pix"
              value="pix-online"
              v-model="pagamento"
            />
            <label style="padding-left: 10px" for="pix">Pix</label>
          </li>
        </ul>
      </div>
      <div class="spinner-border" role="status" v-else>
        <span class="sr-only">Loading...</span>
      </div>

      <br />
      <div style="display: block">
        <input
          style="width: 120px"
          type="text"
          id="cupom"
          value="cupom"
          v-model="cupom"
          class="form-control"
          placeholder="cupom"
        />
        <button
          style="
            align-items: center;
            margin-top: 5px;
            background-color: #006400;
          "
          class="btn btn-dark"
          @click="verificaCupom(cupom)"
        >
          Ativar Cupom
        </button>
      </div>
    </section>

    <br />

    <section
      v-if="
        pagamento === 'pix-online' &&
        (plataformaPix === 'asaas' || plataformaPix === 'paggpix')
      "
      style="
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <h5 style="text-align: center">
        Você será redirecionando a tela de pagamento após finalizar o pedido.
      </h5>
    </section>

    <div
      style="display: flex; justify-content: center; flex-direction: column"
      class="app"
      v-if="pagamento === 'credito-online' && plataformaCartao === 'asaas'"
    >
      <button
        :style="{
          alignItems: 'center',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto,
        }"
        class="btn btn-dark"
      >
        Pagamento por Cartão de Crédito
      </button>
    </div>

    <section
      v-if="pagamento === 'credito-online' && plataformaCartao === 'asaas'"
      style="
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      "
    >
      <h4 style="margin: 12px 0">Informações do Cartão</h4>
      <div class="infoBandeira">
        <span>Aceitamos:</span>
        <div class="bandeiras">
          <img
            src="img/bandeiras/flat-rounded/visa.svg"
            alt="Bandeira de cartão Visa"
          />
          <img
            src="img/bandeiras/flat-rounded/mastercard.svg"
            alt="Bandeira de cartão MasterCard"
          />
          <img
            src="img/bandeiras/flat-rounded/elo.svg"
            alt="Bandeira de cartão ELO"
          />
          <img
            src="img/bandeiras/flat-rounded/discover.svg"
            alt="Bandeira de cartão Discover"
          />
          <img
            src="img/bandeiras/flat-rounded/amex.svg"
            alt="Bandeira de cartão American Express"
          />
        </div>
      </div>
      <label for="holderName">Nome do Títular do Cartão</label>
      <input
        type="text"
        id="holderName"
        v-model="cartao.cardInfo.holderName"
        class="form-control"
        placeholder="João da Silva"
      />
      <label for="numberCard">Número do Cartão</label>
      <input
        type="text"
        id="numberCard"
        v-model="cartao.cardInfo.number"
        class="form-control"
        placeholder="0000 0000 0000 0000"
        v-cleave="{ creditCard: true, onCreditCardTypeChanged: cardChanged }"
      />
      <label for="expiryDate">Data de Vencimento do Cartão</label>
      <input
        type="text"
        id="expiryDate"
        v-model="cartao.cardInfo.expiryDate"
        class="form-control"
        placeholder="MM/AA"
        v-cleave="{ date: true, datePattern: ['m', 'y'] }"
      />
      <label for="cvvCartao">CVV (Código de Segurança do Cartão)</label>
      <input
        type="text"
        id="cvvCartao"
        v-model="cartao.cardInfo.cvv"
        class="form-control"
        placeholder="000"
        v-cleave="{ numericOnly: true, blocks: [4] }"
      />
      <h4 style="margin: 12px 0">Informações do Títular do Cartão</h4>
      <div style="margin-bottom: 12px; display: flex; flex-direction: row">
        <input type="checkbox" id="checkSameAsUser" v-model="sameAsUser" />
        <label style="padding-left: 10px" for="checkSameAsUser"
          >O títular do cartão e o dono da conta são a mesma pessoa?</label
        >
      </div>
      <div v-if="!sameAsUser" style="display: flex; flex-direction: column">
        <label for="nome">Nome Completo</label>
        <input
          type="text"
          id="nome"
          v-model="cartao.cardHolderInfo.name"
          class="form-control"
          placeholder="João da Silva"
        />
        <label for="email">Email</label>
        <input
          type="text"
          id="email"
          v-model="cartao.cardHolderInfo.email"
          class="form-control"
          placeholder="joao@gmail.com"
        />
        <label for="phone">Telefone (Com DDD)</label>
        <input
          type="text"
          id="phone"
          v-model="cartao.cardHolderInfo.phone"
          class="form-control"
          placeholder="00 00000-0000"
          v-cleave="{ phone: true, phoneRegionCode: 'BR' }"
        />
        <label for="cpfCnpj">CPF (Cadastro de Pessoa Física)</label>
        <input
          type="text"
          id="cpfCnpj"
          v-model="cartao.cardHolderInfo.cpfCnpj"
          class="form-control"
          placeholder="000.000.000-00"
          v-cleave="{
            numericOnly: true,
            delimiters: ['.', '.', '-'],
            blocks: [3, 3, 3, 2],
          }"
        />
      </div>
      <div
        v-if="endereco_cd === 'retirarLocal' || endereco_cd === ''"
        style="display: flex; flex-direction: column"
      >
        <label for="postalCode">CEP (Código de Endereçamento Postal)</label>
        <input
          type="text"
          id="postalCode"
          v-model="cartao.cardHolderInfo.postalCode"
          class="form-control"
          placeholder="00000-000"
          v-cleave="{
            numericOnly: true,
            delimiter: '-',
            blocks: [5, 3],
          }"
        />
        <label for="addressNumber">Número do Endereço</label>
        <input
          type="text"
          id="addressNumber"
          v-model="cartao.cardHolderInfo.addressNumber"
          class="form-control"
          placeholder="123"
        />
        <label for="addressComplement">Complemento (Opcional)</label>
        <input
          type="text"
          id="addressComplement"
          v-model="cartao.cardHolderInfo.addressComplement"
          class="form-control"
          placeholder="Casa"
        />
      </div>
    </section>

    <br />
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: start;
        flex-direction: column;
      "
      v-if="cdAgendamento == 1"
    >
      <button
        :style="{
          alignItems: 'center',
          width: '100%',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto,
        }"
        class="btn btn-dark"
      >
        Agendamento pedido
      </button>
      <br />
      <div v-if="this.mostrarAgendamento">
        <div style="display: flex">
          <input
            type="checkbox"
            id="agendamento"
            value="agendamento"
            v-model="checkedAgendamento"
            style="accent-color: #000; margin-right: 8px"
          />
          <label for="agendamento">Deseja agendar seu pedido? </label>
        </div>
        <div
          v-if="checkedAgendamento.length > 0"
          style="
            display: flex;
            justify-content: center;
            align-items: start;
            flex-direction: column;
          "
        >
          <input
            style="padding: 8px"
            type="datetime-local"
            v-model="dataAgendamento"
            id="dataencomenda"
            name="dataencomenda"
            class="custom-datetime"
            :min="minDateTime"
          />
        </div>
      </div>
      <div v-else>
        <div style="display: flex; align-items: center">
          <input
            type="checkbox"
            disabled
            style="accent-color: #aaa; margin-right: 8px"
          />
          <label style="color: #aaa">Agendamento indisponível</label>
          <span
            style="
              margin-left: 8px;
              cursor: help;
              color: #fff;
              font-weight: bold;
              border: 1px solid #ccc;
              border-radius: 50%;
              width: 20px;
              height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              background-color: #000;
            "
            :title="
              'os produtos: ' +
              this.produtosSemAgendamento.map((p) => p.nm) +
              ' não permite agendamento'
            "
          >
            ?
          </span>
        </div>
      </div>
      <br />
    </div>
    <div style="display: flex; align-items: center; justify-content: flex-end">
      <label v-if="taxa == ''">Valor total: R$ {{ total.toFixed(2) }}</label>
      <label v-else
        >Valor total: R$ {{ (total + parseFloat(taxa)).toFixed(2) }}</label
      >
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #8b0000;
      "
    >
      <div
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <button
          style="
            align-items: center;
            margin-top: 5px;
            margin-bottom: 5px;
            margin-right: 5px;
            background-color: #dc3545;
          "
          class="btn btn-dark"
          @click="pushSair()"
        >
          Sair
        </button>
      </div>
      <button
        style="
          align-items: center;
          margin-top: 5px;
          margin-bottom: 5px;
          background-color: #006400;
        "
        :disabled="isDisabled"
        class="btn btn-dark"
        @click="salvarVenda(products, cd_usuario)"
      >
        Finalizar pedido
      </button>
    </div>
    <br />
  </div>
</template>
<style>
.botao {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}
.custom-datetime {
  padding: 10px;
  border: 2px solid #545454; /* Borda azul */
  border-radius: 5px; /* Arredondar os cantos */
  font-size: 16px; /* Tamanho da fonte */
  color: #545454; /* Cor do texto */
  background-color: #f0f0f0; /* Fundo mais claro */
  transition: border-color 0.3s, box-shadow 0.3s; /* Suavizar a transição de borda e sombra */
}

.custom-datetime:focus {
  border-color: #545454; /* Borda azul mais escura ao focar */
  box-shadow: 0 0 5px rgba(84, 84, 84, 0.5); /* Sombra ao focar */
  outline: none; /* Remover contorno padrão */
}

.custom-datetime::-webkit-calendar-picker-indicator {
  background-color: #f0f0f0; /* Cor do ícone do calendário */
  padding: 5px;
  border-radius: 50%;
}

.radio-tabs {
  display: flex;
  border-bottom: 1px solid #ccc;
  margin-bottom: 25px;
}

.radio-input {
  display: none;
}

.radio-label {
  font-size: 1rem;
  font-weight: 500;
  color: #777;
  cursor: pointer;
  padding: 10px 10px;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease-in-out;
}

.radio-input:checked + .radio-label {
  color: #333;
  font-weight: bold;
  border-bottom: 2px solid #333;
}

.telaCarregamento {
  height: 100dvh;
  width: 100dvw;
  position: absolute;
  top: 0px;
  left: 0px;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  z-index: 9999;
  gap: 12px;
}

.telaCarregamento.aberto {
  display: flex;
  animation: fade-in 0.4s forwards;
}

.telaCarregamento.fechado {
  display: none;
  animation: fade-out 0.4s forwards;
}

@keyframes fade-in {
  from {
    display: flex;
    opacity: 0;
  }

  to {
    display: flex;
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    display: flex;
    opacity: 1;
  }

  to {
    display: flex;
    opacity: 0;
  }
}

.infoBandeira {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
  gap: 6px;
}

.bandeiras {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.bandeiras img {
  height: 25px;
  aspect-ratio: 2/1;
}

.divFormControl {
  display: block;
  width: 100%;
  padding: 0.25rem 0.2rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #495057;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  height: calc(1.5em + 0.75rem + 2px);
}

.divFormControl input {
  all: unset;
  height: 100%;
}

.divFormControl span {
  margin: 0 4px;
}

.disabled-radio {
  opacity: 0.4;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import creditCardType from "credit-card-type";
import Cupom from "../services/cupom";
import Inis from "../services/inis";
import Usuario from "../services/usuario";
import Endereco from "../services/endereco";
import Venda from "../services/venda";
import Cardapio from "../services/cardapio";
import Swal from "sweetalert2";
import Bandeira from "../services/bandeira";
import axios from "axios";
import api from "../services/api";
import Raio from "../services/raio";
import EnderecoRaio from "../services/endereco_raio";

export default {
  name: "FinalizadoLogin",
  data() {
    return {
      msgEntrega: "",
      msgRetirada: "",
      msgBuscaFone: "",
      estado: "",
      cidade: "",
      bairro: "",
      rua: "",
      numero: "",
      complemento: "",
      referencia: "",
      cep: "",
      latitude: "",
      longitude: "",
      LatLoja: "",
      LonLoja: "",
      distanciaUsuario: "",
      possuiRaio: false,
      tipoEntrega: "1",
      email: "",
      enderecos: {},
      raio: {},
      cd_usuario: "",
      usuarios: [],
      cd: "",
      tipoPagamento: "entrega",
      pagamento: "",
      checkedEndereco: "",
      taxa: "",
      telaCarregamento: "",
      endereco_cd: "",
      inis_valores: [],
      inis_valor: [],
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      vendaspedidos: [],
      vendas: [],
      venda: {
        cd: "",
        total: "",
        dt: "",
        cd_usu: "",
        status: "",
        forma: "",
        troco: "",
        taxa: "",
        vl_desc: "",
      },
      telefone: "",
      corBotao: "",
      corTexto: "",
      corFundo: "",
      nomecompleto: "",
      valorDinheiro: "",
      valorTotal: "",
      valorTroco: 0,
      retirarBoolean: false,
      retirarLocalInis: true,
      somenteRetirada: true,
      valorMinimo: 0,
      cupom: "",
      cupomAprovado: "",
      desconto: {},
      jaUsado: "",
      quantidade: "",
      estoque: "",
      quantidadeInvalida: false,
      qtd: [],
      quantidadeArray: [],
      cupomAux: "",
      cupomAtivado: false,
      bandeiras: [],
      spinnerEndereco: true,
      spinnerCartao: true,
      win: "",
      idPixel: "",
      cadastro: "",
      cel: "",
      possuiAsaas: false,
      possuiMercadoPago: false,
      plataformaCartao: "",
      plataformaPix: "",
      pagamentoOnline: "",
      isDisabled: false,
      dataAgendamento: "",
      cdAgendamento: -1,
      mostrarAgendamento: true,
      produtosSemAgendamento: [],
      checkedAgendamento: [],
      minDateTime: "",
      DateMinTime: "",
      tempoMininoAgendar: 0,
      comerLocalHabilitado: 0,
      publicKey: "",
      valorBase: 0,
      sameAsUser: true,
      liberarPagOnline: false,
      somenteAgendamento: "0",
      cartao: {
        cardInfo: {
          holderName: "",
          number: "",
          expiryDate: "",
          expiryMonth: "",
          expiryYear: "",
          cvv: "",
        },
        cardHolderInfo: {
          sameAsUser: "",
          name: "",
          email: "",
          cpfCnpj: "",
          postalCode: "",
          addressNumber: "",
          addressComplement: "",
          phone: "",
        },
      },
      cursorPosMonthAnterior: 0,
      cursorPosYearAnterior: 0,
    };
  },
  computed: {
    ...mapGetters({
      products: "cartProducts",
      logado: "retornaLogado",
    }),
    total() {
      var desconto;
      var somatorio = 0;
      var valor = 0;
      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl * this.products[i].quantity;
        }
        somatorio = somatorio + valor;
      }

      this.valorTotal = somatorio;

      if (this.desconto.tipo == "V") {
        desconto = this.desconto.valor;
        return (this.valorTotal = this.valorTotal - parseFloat(desconto));
      } else if (this.desconto.tipo == "P") {
        desconto = (this.valorTotal * parseFloat(this.desconto.valor)) / 100;
        return (this.valorTotal = this.valorTotal - desconto);
      } else {
        return this.valorTotal;
      }
    },
    buscaTroco() {
      var troco;
      if (this.pagamento == "dinheiro") {
        /* if (this.taxa == "") {
           - parseFloat(this.valorTotal);
        } else {
          troco = parseFloat(this.valorDinheiro) - (parseFloat(this.valorTotal) + parseFloat(this.taxa));
        } */
        troco = parseFloat(this.valorDinheiro);
        if (troco == 0) {
          return (troco = "Não precisa de troco");
        } else {
          troco = parseFloat(troco).toFixed(2);
          this.valorTroco = troco;
          return troco;
        }
      } else {
        return (troco = "Não precisa de troco");
      }
    },
  },
  methods: {
    showTelaCarregamento(aberto) {
      if (aberto) {
        this.telaCarregamento = "aberto";
      } else {
        this.telaCarregamento = "fechado";
      }
    },
    validarCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, "");

      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
        return false;
      }

      let soma = 0;
      for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let resto = 11 - (soma % 11);
      let digito1 = resto >= 10 ? 0 : resto;

      soma = 0;
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
      }
      resto = 11 - (soma % 11);
      let digito2 = resto >= 10 ? 0 : resto;

      return (
        digito1 === parseInt(cpf.charAt(9)) &&
        digito2 === parseInt(cpf.charAt(10))
      );
    },
    async atualizarInformacoes(campos) {
      try {
        let nmValidado, cpfValidado, emailValidado, foneValidado;

        if (campos.includes("nm")) {
          const { value: nm } = await Swal.fire({
            title: "Qual seu nome completo?",
            input: "text",
            inputPlaceholder: "João da Silva",
            allowOutsideClick: false,
            allowEscapeKey: false,
            inputValidator: (value) => {
              if (!value) return "Por favor insira o seu nome completo!";
              if (value.length < 3 && value.length > 60)
                return "O tamanho do nome é inválido!";
            },
          });

          nmValidado = nm;
        }

        if (campos.includes("cpf")) {
          const { value: cpf } = await Swal.fire({
            title: "Qual seu CPF?",
            input: "text",
            inputPlaceholder: "000.000.000-00",
            allowOutsideClick: false,
            allowEscapeKey: false,
            inputValidator: (value) => {
              if (!value) return "Por favor insira o seu CPF!";
              if (!this.validarCPF(value))
                return "Por favor insira um CPF válido!";
            },
          });

          cpfValidado = cpf.replaceAll(/[\D]/g, "");
        }

        if (campos.includes("email")) {
          const { value: email } = await Swal.fire({
            title: "Qual seu email?",
            input: "text",
            inputPlaceholder: "example@gmail.com",
            allowOutsideClick: false,
            allowEscapeKey: false,
            inputValidator: (value) => {
              if (!value) return "Por favor insira o seu email!";
              if (
                !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
                  value
                )
              )
                return "O email é inválido!";
            },
          });

          emailValidado = email;
        }

        if (campos.includes("fone")) {
          const { value: fone } = await Swal.fire({
            title: "Qual seu telefone (Com DDD)?",
            input: "text",
            inputPlaceholder: "(00) 00000-0000",
            allowOutsideClick: false,
            allowEscapeKey: false,
            inputValidator: (value) => {
              if (!value) return "Por favor insira o seu telefone!";
              if (!/^\d{2}(9\d{8}|\d{8})$/.test(value.replaceAll(/[\D]/g, "")))
                return "O telefone é inválido!";
            },
          });

          foneValidado = fone.replaceAll(/[\D]/g, "");
        }

        try {
          await api.put(
            "/cliente/atualizar-info",
            {
              nm: nmValidado,
              cpf: cpfValidado,
              email: emailValidado,
              fone: foneValidado,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  "token" + localStorage.getItem("contrato")
                )}`,
              },
            }
          );

          this.liberarPagOnline = true;
          this.tipoPagamento = "site";
          document.getElementById("site").checked = true;

          Swal.fire({
            icon: "success",
            title: "Suas informações foram atualizadas!",
            text: "As informações do seu usuário foram atualizadas com sucesso!",
            confirmButtonText: "Ok",
          });
        } catch (err) {
          console.log(err);
          const response = await Swal.fire({
            icon: "error",
            title: "Algo ocorreu errado ao atualizar!",
            text: "Ocorreu um erro inesperado ao tentar atualizar suas informações, tente novamente!",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Tentar novamente",
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          if (!response.isDismissed) {
            return this.atualizarInformacoes(campos);
          }
        }
      } catch {}
    },
    async verficarAgendamentoProdutos() {
      for (const prod of this.products) {
        if (prod.agendamento == "0" || prod.agendamento == null) {
          this.mostrarAgendamento = false;
          this.produtosSemAgendamento.push(prod);
        }
        console.log(this.produtosSemAgendamento);
      }
    },
    async trocarTipoPagamento(tipo) {
      if (!this.liberarPagOnline && tipo === "site") {
        try {
          const response = await api.get("/cliente/verificar", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "token" + localStorage.getItem("contrato")
              )}`,
            },
          });
          if (!response.data.verified) {
            this.tipoPagamento = "entrega";
            document.getElementById("entrega").checked = true;
            const responseInfo = await Swal.fire({
              icon: "info",
              title: "Precisamos de mais informações!",
              text: "Para prosseguir ao pagamento online precisamos de mais informações suas.",
              showCancelButton: true,
              cancelButtonText: "Cancelar",
              confirmButtonText: "Prosseguir",
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
            if (responseInfo.isDismissed) {
              return;
            }
            return await this.atualizarInformacoes(response.data.campos);
          } else {
            this.liberarPagOnline = true;
          }
        } catch {
          return Swal.fire({
            icon: "error",
            title: "Erro ao carregar pagamento Online!",
            text: "Ocorreu um erro inesperado ao carregar os métodos de pagamento online, tente mais tarde novamente!",
            confirmButtonText: "Ok",
          });
        }
      }
      this.pagamento = "";
      this.tipoPagamento = tipo;
      document.getElementById(tipo).checked = true;
      await this.iniciarMercadoPago();
    },
    pushSair() {
      localStorage.removeItem("email" + localStorage.getItem("contrato"));
      localStorage.removeItem("nm" + localStorage.getItem("contrato"));
      localStorage.removeItem("cd" + localStorage.getItem("contrato"));
      this.$store.commit("setLogado", false);

      this.$router.push("/login");
    },
    push() {
      this.email = localStorage.getItem(
        "email" + localStorage.getItem("contrato")
      );
      this.cel = localStorage.getItem(
        "telefone" + localStorage.getItem("contrato")
      );
      this.$router.push("/endereco");
    },
    pushEnderecos() {
      this.$router.push("/endereco");
    },
    listarInisValorMinimo() {
      var cd = "VL_MIN_PEDIDO";
      Inis.listarInisCd(cd).then((resposta) => {
        this.valorMinimo = resposta.data[0].vl;
      });
    },
    async listandoEnderecos() {
      // if (this.possuiRaio && this.tipoEntrega === "2") {
      //   this.enderecos = (
      //     await api("/endereco/raio", {
      //       headers: {
      //         Authorization: `Bearer ${localStorage.getItem(
      //           "token" + localStorage.getItem("contrato")
      //         )}`,
      //       },
      //     })
      //   ).data;
      // } else if (this.possuiRaio && this.tipoEntrega === "3") {
      //   this.enderecos = (
      //     await api("/endereco/rota", {
      //       headers: {
      //         Authorization: `Bearer ${localStorage.getItem(
      //           "token" + localStorage.getItem("contrato")
      //         )}`,
      //       },
      //     })
      //   ).data;
      // } else if (this.possuiRaio && this.tipoEntrega === "4") {
      //   this.enderecos = (
      //     await api("/endereco/area", {
      //       headers: {
      //         Authorization: `Bearer ${localStorage.getItem(
      //           "token" + localStorage.getItem("contrato")
      //         )}`,
      //       },
      //     })
      //   ).data;
      // } else {
      //   this.enderecos = (
      //     await api("/endereco/bairro", {
      //       headers: {
      //         Authorization: `Bearer ${localStorage.getItem(
      //           "token" + localStorage.getItem("contrato")
      //         )}`,
      //       },
      //     })
      //   ).data;
      // }
      var endereco;
      if (this.possuiRaio && this.tipoEntrega === "2") {
        endereco = await EnderecoRaio.listandoEnderecos(
          localStorage.getItem("cd" + localStorage.getItem("contrato"))
        );
        this.enderecos = endereco.data;
        this.verificaEntregaRaio();
      } else if (this.possuiRaio && this.tipoEntrega === "3") {
        this.enderecos = (
          await api("/endereco/rota", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "token" + localStorage.getItem("contrato")
              )}`,
            },
          })
        ).data;
      } else if (this.possuiRaio && this.tipoEntrega === "4") {
        this.enderecos = (
          await api("/endereco/area", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "token" + localStorage.getItem("contrato")
              )}`,
            },
          })
        ).data;
      } else {
        endereco = await Endereco.listandoEnderecos(
          localStorage.getItem("cd" + localStorage.getItem("contrato"))
        );
        this.enderecos = endereco.data;
      }
      if (this.cadastro != 3) {
        var usuario = await Usuario.getByEmail(this.email);
        this.usuarios = usuario.data;
        this.cd_usuario = usuario.data[0].cd;
        this.nomecompleto = usuario.data[0].nm;
        this.telefone = usuario.data[0].fone;
        this.retirarBoolean = true;
        this.spinnerEndereco = false;
      } else {
        var usuario = await Usuario.getByFone(this.cel);
        this.usuarios = usuario.data;
        this.cd_usuario = usuario.data[0].cd;
        this.nomecompleto = usuario.data[0].nm;
        this.telefone = usuario.data[0].fone;
        this.retirarBoolean = true;
        this.spinnerEndereco = false;
      }
    },
    validarEndereco(taxa, cd, endereco, latitude, longitude) {
      if (
        this.possuiRaio &&
        this.tipoEntrega === "3" &&
        this.tipoEntrega === "4"
      ) {
        this.taxaEndereco(taxa);
      } else {
        if (latitude != "" && longitude != "") {
          this.taxaEndereco(taxa);
        }
      }
      this.codigoEndereco(cd);
      this.salvarEndereco(endereco);
    },
    async buscaRaio() {
      try {
        this.raio = await Raio.listandoRaio();
      } catch (error) {
        console.log("Não foi possível pegar os raios de distância");
      }
    },
    async verificaEntregaRaio() {
      try {
        await this.buscaRaio();
        const respostaInis = await Inis.listarInisCd("TIPO_ENTREGA");

        if (respostaInis.data[0].vl === "2") {
          for (const endereco of this.enderecos) {
            endereco.taxa = this.valorBase;

            this.$set(endereco, "entregaPorRaioDisponivel", false);

            if (endereco.cep != "") {
              this.distanciaUsuario = await this.calculaLatLon(
                endereco.latitude,
                endereco.longitude
              );

              let taxaDentroDoAlcance = false;

              for (const distanciaTabela of this.raio.data) {
                const distanciaRaio = parseFloat(distanciaTabela.distancia);
                const taxaRaio = parseFloat(distanciaTabela.taxa);
                const ativoRaio = distanciaTabela.ativo === "1";

                if (this.distanciaUsuario <= distanciaRaio && ativoRaio) {
                  endereco.taxa = taxaRaio;
                  taxaDentroDoAlcance = true;
                  this.$set(endereco, "entregaPorRaioDisponivel", true);
                  break;
                }
              }

              if (!taxaDentroDoAlcance) {
                endereco.taxa = 0;
                Swal.fire({
                  icon: "error",
                  title: "Aviso!",
                  text: `Infelizmente não atendemos o endereço: ${endereco.rua}, ${endereco.bairro}`,
                  confirmButtonColor: "#000000",
                });
              }
            }
          }
        } else {
          console.log("Entrega do tipo Bairro");
        }
      } catch (error) {
        console.error("Não foi possível listar as distâncias: ", error);
      }
    },
    async calculaLatLon(latitude, longitude) {
      try {
        await Inis.listarInisCd("LATITUDE").then((resposta) => {
          this.LatLoja = resposta.data[0].vl;
        });

        await Inis.listarInisCd("LONGITUDE").then((resposta) => {
          this.LonLoja = resposta.data[0].vl;
        });

        const response = await axios.get(
          `https://panterafood-a6be668f1a6b4c5c.api.findcep.com/v1/geolocation/distance/from/latlon/${latitude},${longitude}/to/latlon/${this.LatLoja},${this.LonLoja}`,
          {
            headers: {
              Referer: "E331DRRF15B7E8",
            },
          }
        );

        const data = response.data;
        this.distanciaUsuario = parseFloat(data.distance).toFixed(1);

        return this.distanciaUsuario;
      } catch (error) {
        console.error(
          "Não foi possível calcular a distância entre as coordenadas",
          error
        );
      }
    },
    existeCep(id, cep) {
      if (this.possuiRaio && this.tipoEntrega === "2") {
        if (!cep) {
          const radio = document.getElementById(id);
          if (radio) {
            radio.checked = false;
            radio.disabled = true;

            Swal.fire({
              icon: "info",
              title: "Atualize seu cadastro!",
              text: "Nosso sistema de entregas foi aprimorado, crie um novo endereço de entrega com seu CEP!",
              confirmButtonColor: "#000000",
            });
          }
          return false;
        }
        return true;
      } else {
        return true;
      }
    },
    enderecoFora(id) {
      document.getElementById(id).checked = false;
      Swal.fire({
        icon: "error",
        title: "Endereço Fora de Alcance",
        text: "Infelizmente não estamos entregando neste endereço!",
      });
    },
    /*.then((resposta) => {
          this.usuarios = resposta.data;
          this.usuarios.forEach((usuario) => {
            if (this.cadastro != 3) {
              if (usuario.email == this.email) {
                this.cd_usuario = usuario.cd;
                this.nomecompleto = usuario.nm;
                this.telefone = usuario.fone;
                this.retirarBoolean = true;
                this.spinnerEndereco = false;
              }
            } else {
              console.log(usuario.fone == this.cel)
              console.log(usuario.fone)
              console.log(this.cel)
              if (usuario.fone == this.cel) {
                this.cd_usuario = usuario.cd;
                this.nomecompleto = usuario.nm;
                this.telefone = usuario.fone;
                this.retirarBoolean = true;
                this.spinnerEndereco = false;
              }
            }
          });
        });*/
    async verificaCupom(cupom) {
      if (this.cupomAtivado == true) {
        Swal.fire({
          title: "Um cupom já foi aplicado",
          confirmButtonColor: "#000000",
        });
      } else {
        Cupom.verificacupom(cupom).then((resposta) => {
          this.cupomAux = resposta.data;
          if (resposta.data == null) {
            Swal.fire({
              title: "Cupom inexistente",
              confirmButtonColor: "#000000",
            });
          } else {
            Cupom.verificacupomusado(this.cd_usuario, this.cupomAux[0].cd).then(
              (resposta) => {
                this.jaUsado = resposta.data;
                if (this.cupomAux[0].repetivel == "1") {
                  this.jaUsado = null;
                }
                if (this.jaUsado != null) {
                  Swal.fire({
                    title: "Cupom já utilizado",
                    confirmButtonColor: "#000000",
                  });
                } else {
                  if (parseFloat(this.cupomAux[0].vl_min) > this.total) {
                    Swal.fire({
                      title:
                        "Valor mínimo de " +
                        this.cupomAux[0].vl_min +
                        " reais para usar o cupom",
                      confirmButtonColor: "#000000",
                    });
                  } else {
                    this.desconto = {
                      tipo: this.cupomAux[0].tipo,
                      valor: this.cupomAux[0].valor,
                      cd: this.cupomAux[0].cd,
                      qtd: this.cupomAux[0].qtd,
                    };

                    Swal.fire({
                      title: "Cupom aprovado",
                      confirmButtonColor: "#000000",
                    });
                    this.cupomAprovado = cupom;
                    this.cupomAtivado = true;
                  }
                }
              }
            );
          }
        });
        this.jaUsado = "";
      }
    },
    codigoEndereco(cd) {
      console.log(cd);
      this.endereco_cd = cd;
    },
    salvarEndereco(endereco) {
      this.estado = endereco.uf;
      this.cidade = endereco.nm_cid;
      this.bairro = endereco.bairro;
      this.rua = endereco.rua;
      this.numero = endereco.numero;
      this.complemento = endereco.complemento;
      this.referencia = endereco.proximidade;
    },
    taxaEndereco(taxa) {
      this.taxa = parseFloat(taxa).toFixed(2);
      taxa = parseFloat(taxa).toFixed(2);
      return taxa;
    },

    retornar_cd_endereco(cd) {
      this.cd = cd;
    },
    async listarBandeiras() {
      await Bandeira.listarbandeiras().then((resposta) => {
        this.bandeiras = resposta.data.filter((bandeira) => {
          if (bandeira.ativo == "1") {
            return bandeira;
          }
        });
      });
      this.spinnerCartao = false;
    },
    listarpedidosvenda(venda) {
      Venda.listarpedidosvenda().then((resposta) => {
        this.vendaspedidos = resposta.data;
        //alert(JSON.stringify(this.vendaspedidos[0]));
      });
    },
    listandoInisEstoque() {
      var cd = "CONTROLA_ESTOQUE";
      Inis.listarInisCd(cd).then((resposta) => {
        this.estoque = resposta.data[0].vl;
      });
    },
    async listandoInisRetirarLocal() {
      var cd = "RETIRAR_LOCAL";
      await Inis.listarInisCd(cd).then((resposta) => {
        if (resposta.data[0].vl == 0) {
          this.retirarLocalInis = false;
        } else if (resposta.data[0].vl == 1) {
          this.retirarLocalInis = true;
        }
      });
    },
    async listandoInisSomenteRetirada() {
      var cd = "SOMENTE_RETIRADA";
      await Inis.listarInisCd(cd).then((resposta) => {
        if (resposta.data[0].vl == 0) {
          this.somenteRetirada = false;
        } else if (resposta.data[0].vl == 1) {
          this.somenteRetirada = true;
        }
      });
    },
    //listarinisvalores
    listarinisvalores() {
      Inis.listarinisvalores().then((resposta) => {
        this.inis_valores = resposta.data;
        //alert(resposta.data);
      });
    },
    //listarinis
    async listarinis() {
      await Inis.listarinis().then((resposta) => {
        this.inis_valor = resposta.data;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corTexto = resposta.data[0].vl;
      });
      var cd = "TIPO_LOGIN";
      Inis.listarInisCd(cd).then((resposta) => {
        this.cadastro = resposta.data[0].vl;
      });
      var cd = "ID_PIXEL";
      Inis.listarInisCd(cd).then((response) => {
        this.idPixel = response.data[0].vl;
        if (this.idPixel != "") {
          this.loadFacebookPixel(this.idPixel, "InitiateCheckout", "");
        }
      });
      var cd = "AGENDAMENTO";
      Inis.listarInisCd(cd).then((resposta) => {
        this.cdAgendamento = resposta.data[0].vl;
      });
      var cd = "SOMENTE_AGENDAMENTO";
      await Inis.listarInisCd(cd).then((resposta) => {
        this.somenteAgendamento = resposta.data[0].vl;
      }).catch(() => {
        this.somenteAgendamento = "0";
      });

      await Inis.listarInisCd("POSSUI_RAIO").then((resposta) => {
        this.possuiRaio = resposta.data[0].vl === "1";
      });
      await Inis.listarInisCd("TIPO_ENTREGA").then((resposta) => {
        this.tipoEntrega = resposta.data[0].vl;
      });

      await Inis.listarInisCd("POSSUI_ASAAS").then((resposta) => {
        this.possuiAsaas = resposta.data[0].vl === "1";
      });

      try {
        const resposta = await Inis.listarInisCd("COMER_LOCAL");
        if (
          resposta &&
          resposta.data &&
          resposta.data.length > 0 &&
          resposta.data[0].vl !== undefined
        ) {
          this.comerLocalHabilitado = parseInt(resposta.data[0].vl, 10);
        } else {
        }
      } catch (erro) {
        this.comerLocalHabilitado = 0;
      }
      console.log("comer localinis", this.comerLocalHabilitado);
      // await Inis.listarInisCd("POSSUI_MERCADOPAGO").then((resposta) => {
      //   this.possuiMercadoPago = resposta.data[0].vl === "1";
      // });
      await Inis.listarInisCd("PLATAFORMA_CARTAO").then((resposta) => {
        this.plataformaCartao = resposta.data[0].vl;
      });
      await Inis.listarInisCd("PLATAFORMA_PIX").then((resposta) => {
        this.plataformaPix = resposta.data[0].vl;
      });
      await Inis.listarInisCd("PAGAMENTO_ONLINE").then((response) => {
        this.pagamentoOnline = response.data[0].vl;
      });
    },
    buscacodigo() {
      var mesge = "";
      var cd = "";
      var maisum = "1";

      if (this.vendaspedidos[0] && this.vendaspedidos[0].cd) {
        Venda.buscacodigo().then((resposta) => {
          this.vendaspedidos = resposta.data;
        });
        mesge = (
          parseFloat(this.vendaspedidos[0].cd) + parseFloat(maisum)
        ).toFixed(0);
      }

      return mesge;
    },
    buscafone() {
      var cdf = "WHATSAPP";

      var msge = "";

      Inis.buscafone(cdf).then((resposta) => {
        this.inis_valor = resposta.data;
        // console.log(this.inis_valor, "this.inis_valor");
        this.msgBuscaFone = this.inis_valor[0].vl;
        //  console.log(this.msgBuscaFone, "this.msgBuscaFone");
      });

      // msge = this.inis_valor[0].vl;
      // console.log(msge, "msge");

      //alert(JSON.stringify(this.inis_valor[0].vl));
    },
    getMsgPedido() {
      const data = new Date(this.dataAgendamento);
      const dataFormatted = data.toLocaleDateString("pt-BR");
      const timeFormatted = data.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });

      if (this.endereco_cd == "retirarLocal") {
        this.msgRetirada = `Tempo agendado para retirada: ${dataFormatted} às ${timeFormatted}`;
      } else {
        this.msgEntrega = `Tempo agendado para entrega: ${dataFormatted} às ${timeFormatted}`;
      }
    },
    buscaentrega() {
      var cde = "TEMPO_ENTREGA";

      Inis.buscaentrega(cde).then((resposta) => {
        this.inis_valores = resposta.data;
        this.msgEntrega = this.inis_valores[0].vl;
      });
    },
    buscaretirada() {
      var cdr = "TEMPO_RETIRADA";
      var vl = "";

      Inis.buscaretirada(cdr).then((resposta) => {
        this.inis_valores = resposta.data;
        this.msgRetirada = this.inis_valores[0].vl;
      });
    },

    buscavalor(preco) {
      var somatorio = 0;
      var valor = 0;

      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl * this.products[i].quantity;
        }
        somatorio = somatorio + valor;
      }
      return somatorio;
    },

    whatsapp(itens) {
      let retorno = "";

      for (const [index, item] of itens.entries()) {
        let listaAdicionais = "";

        if (item.adicionaispergunta && item.adicionaispergunta.length > 0) {
          listaAdicionais =
            "- " +
            item.adicionaispergunta
              .map((adicionais) => adicionais.nm.trim())
              .join(", ") +
            ", ";
        }
        if (item.obs != "" && itens.length - 1 == index) {
          listaAdicionais += item.obs;
        }

        retorno += `${parseInt(item.quantity)}x ${
          item.nm
        } ${listaAdicionais}%0A`;
      }

      return retorno;
    },

    menosqtd(p) {
      if (p.quantity >= "2") {
        p.quantity -= 1;
      } else {
        Swal.fire({
          title: "Obrigatório ter pelo menos um item desse produto.",
          confirmButtonColor: "#000000",
        });
      }
    },
    somatorio() {
      var somatorio = 0;
      var valor = 0;

      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl * this.products[i].quantity;
        }
        somatorio = somatorio + valor;
      }
      return somatorio;
    },

    somarqtd(p) {
      p.quantity += 1;
    },

    del(index) {
      this.products.splice(index, 1);
    },
    deletarEndereco() {
      var e = new Object();
      e.cd = this.codigoEndereco;
      Endereco.deletarEnderecos(e).then(function (response) {
        Swal.fire({ title: response.data, confirmButtonColor: "#000000" });
      });
    },
    loadFacebookPixel(idPixel, type, total) {
      var script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      script.async = true;

      var initCode = 'fbq("init", "' + idPixel + '");';

      var noscript = document.createElement("noscript");
      var img = document.createElement("img");
      img.height = 1;
      img.width = 1;
      img.style.display = "none";
      if (total == "") {
        img.src =
          "https://www.facebook.com/tr?id=" +
          idPixel +
          `&ev=${type}&noscript=1`;
      } else {
        img.src =
          "https://www.facebook.com/tr?id=" +
          idPixel +
          `&ev=${type}&noscript=1` +
          "&cd[value]=" +
          total.toFixed(2) +
          "&cd[currency]=BRL";
      }

      noscript.appendChild(document.createTextNode(initCode));
      noscript.appendChild(img);

      document.head.appendChild(script);
      document.head.appendChild(noscript);
    },
    async salvarVenda(products, cd_usuario) {
      try {
        this.isDisabled = true;
        if (!(await this.validarCampos())) {
          this.isDisabled = false;
          return false;
        }
        if (
          !this.validateSelectedTime() &&
          this.checkedAgendamento.length > 0
        ) {
          console.log(
            "this.validateSelectedTime()",
            this.validateSelectedTime()
          );
          console.log(
            "this.checkedAgendamento.length",
            this.checkedAgendamento.length
          );
          await Swal.fire({
            title: "Horário inválido!\n Por favor selecione um horário diferente",
            confirmButtonColor: "#000000",
          });
          this.isDisabled = false;
          return false;
        }

        var u = new Object();
        u.cd_endereco = this.cd;
        u.cd_usuario = cd_usuario;

        await Usuario.alterarusuario(u).catch(function (error) {
          alert(error);
        });

        var v = new Object();

        v.cd_usuario = cd_usuario;
        v.bodyMP = null;
        v.forma = this.pagamento;
        v.taxa = this.taxa;
        v.mesa = null;
        v.serie = null;
        v.num_serie = null;
        v.cartao = {
          cardInfo: {
            holderName: this.cartao.cardInfo.holderName,
            number: this.cartao.cardInfo.number.replaceAll(/[\D]/g, ""),
            expiryDate: this.cartao.cardInfo.expiryDate,
            expiryMonth: this.cartao.cardInfo.expiryDate.split("/")[0],
            expiryYear: this.cartao.cardInfo.expiryDate.split("/")[1],
            cvv: this.cartao.cardInfo.cvv.replaceAll(/[\D]/g, ""),
          },
          cardHolderInfo: {
            sameAsUser: this.sameAsUser ? "1" : "0",
            idAddress:
              this.endereco_cd !== "comerLocal" &&
              this.endereco_cd !== "retirarLocal" &&
              this.endereco_cd !== ""
                ? this.enderecos[this.endereco_cd].cd
                : null,
            name: this.cartao.cardHolderInfo.name,
            email: this.cartao.cardHolderInfo.email,
            cpfCnpj: this.cartao.cardHolderInfo.cpfCnpj.replaceAll(/[\D]/g, ""),
            postalCode: this.cartao.cardHolderInfo.postalCode.replaceAll(
              /[\D]/g,
              ""
            ),
            addressNumber: this.cartao.cardHolderInfo.addressNumber.replaceAll(
              /[\D]/g,
              ""
            ),
            addressComplement: this.cartao.cardHolderInfo.addressComplement,
            phone: this.cartao.cardHolderInfo.phone.replaceAll(/[\D]/g, ""),
          },
        };
        if (this.checkedAgendamento.length > 0) {
          v.dt = this.dataAgendamento.replace("T", " ");
          this.getMsgPedido();
        }

        if (this.valorDinheiro == "") {
          v.troco = null;
        } else {
          v.troco = this.valorDinheiro
            .replaceAll(/([.,])(?=[^.,]*$)/g, "#TROCA")
            .replaceAll(/[.,]/g, "")
            .replace("#TROCA", ".");
        }

        v.total = this.somatorio();
        if (!(await this.validarCamposValor(v))) {
          this.isDisabled = false;
          return false;
        }

        if (
          this.plataformaCartao === "asaas" &&
          this.pagamento === "credito-online" &&
          !(await this.validarCamposCartao(v.cartao))
        ) {
          this.isDisabled = false;
          return false;
        }

        if (this.desconto.tipo == "V") {
          v.desconto = this.desconto.valor;
        } else if (this.desconto.tipo == "P") {
          v.desconto = (
            (parseFloat(v.total) * parseFloat(this.desconto.valor)) /
            100
          ).toFixed(2);
        } else {
          v.desconto = "0.00";
        }
        v.total = parseFloat(v.total).toFixed(2);
        v.products = products.map((produto) => {
          if (produto.unitario == "0") {
            produto.quantity = produto.peso;
          }
          return produto;
        });

        if (
          this.pagamento !== "credito-online" &&
          this.pagamento !== "pix-online"
        ) {
          var c = new Object();

          c.cd_usuario = cd_usuario;
          c.cd_cupom = this.desconto.cd;

          Cupom.registracupom(c);

          var cupomQtd = new Object();

          cupomQtd.cd_cupom = this.desconto.cd;
          cupomQtd.qtd = parseInt(this.desconto.qtd) - 1;

          Cupom.atualizaqtd(cupomQtd);
        }

        if (this.estoque == "1") {
          const valores = products.map((prod) => ({
            cd: prod.cd,
            qt: prod.quantity,
          }));

          const quantidadeMap = valores.reduce((acc, { cd, qt }) => {
            acc[cd] = (acc[cd] || 0) + parseInt(qt);
            return acc;
          }, {});

          this.qtd = products.map((prod) => quantidadeMap[prod.cd]);

          const promises = products.map((produto) =>
            Cardapio.listarQtd(produto.cd).then((resposta) =>
              parseFloat(resposta.data[0].estoque)
            )
          );

          this.quantidadeArray = await Promise.all(promises);

          for (let i = 0; i < products.length; i++) {
            const produto = products[i];
            if (this.qtd[i] > this.quantidadeArray[i]) {
              await Swal.fire({
                title: `Produto ${produto.nm} tem no máximo ${this.quantidadeArray[i]} unidades restantes`,
                confirmButtonColor: "#000000",
              });
              this.quantidadeInvalida = true;
              break;
            } else {
              const e = {
                cd: produto.cd,
                qtd: this.quantidadeArray[i] - this.qtd[i],
              };
              await Cardapio.alteraQtd(e);
            }
          }
        }

        if (this.quantidadeInvalida == true) {
          this.isDisabled = false;
          return false;
        }

        let responsePix;

        this.showTelaCarregamento(true);

        if (this.pagamento === "credito-online") {
          try {
            await api.post(
              "/carrinho",
              {
                forma: v.forma,
                mesa: v.mesa,
                serie: v.serie,
                num_serie: v.num_serie,
                troco: v.troco,
                cupom: this.cupomAprovado,
                dt: v.dt,
                cartao: v.cartao,
                products: v.products,
                taxa: v.taxa,
                cd_endereco: this.cd || 0,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "token" + localStorage.getItem("contrato")
                  )}`,
                },
              }
            );
          } catch (err) {
            if (axios.isAxiosError(err)) {
              Swal.fire({
                icon: "error",
                title: "Erro ao realizar o pagamento!",
                text: err.response.data.error ? err.response.data.error : null,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erro ao realizar o pagamento!",
              });
            }
            throw new Error();
          }
        } else if (this.pagamento === "pix-online") {
          try {
            responsePix = await api.post(
              "/carrinho",
              {
                forma: v.forma,
                mesa: v.mesa,
                serie: v.serie,
                num_serie: v.num_serie,
                troco: v.troco,
                cupom: this.cupomAprovado,
                dt: v.dt,
                products: v.products,
                taxa: v.taxa,
                cd_endereco: this.cd || 0,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "token" + localStorage.getItem("contrato")
                  )}`,
                },
              }
            );
          } catch (err) {
            if (axios.isAxiosError(err)) {
              Swal.fire({
                icon: "error",
                title: "Erro ao finalizar o pedido!",
                text: err.response.data.error ? err.response.data.error : null,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erro ao finalizar o pedido!",
              });
            }
            throw new Error();
          }
        } else {
          try {
            await Venda.salvarvenda(v);
          } catch {
            Swal.fire({
              icon: "error",
              title: "Erro ao finalizar o pedido!",
            });
            throw new Error();
          }
        }

        if (this.idPixel != "") {
          this.loadFacebookPixel(this.idPixel, "Purchase", this.total);
        }

        let linkWpp = "";

        if (this.endereco_cd == "comerLocal") {
          this.tipo = "Comer no local";

          linkWpp =
            "https://api.whatsapp.com/send?phone=" +
            this.msgBuscaFone +
            "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
            this.buscacodigo(this.vendaspedidos) +
            "*%0A---------------------------------------%0A%0A" +
            this.whatsapp(this.products) +
            "%0A* Total:%20R$%20" +
            this.total.toFixed(2) +
            "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
            this.buscaTroco +
            "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
            this.pagamento +
            "%0A%0A---------------------------------------%0A%0A*" +
            this.nomecompleto +
            "*%0A" +
            this.telefone +
            "%0A%0A---------------------------------------%0A%0A*" +
            this.tipo +
            "%20no%20local*%0A%0A---------------------------------------%0A%0A*" +
            this.msgRetirada +
            "*";
        } else if (this.endereco_cd == "retirarLocal") {
          this.tipo = "Retirada no local";

          linkWpp =
            "https://api.whatsapp.com/send?phone=" +
            this.msgBuscaFone +
            "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
            this.buscacodigo(this.vendaspedidos) +
            "*%0A---------------------------------------%0A%0A" +
            this.whatsapp(this.products) +
            "%0A* Total:%20R$%20" +
            this.total.toFixed(2) +
            "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
            this.buscaTroco +
            "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
            this.pagamento +
            "%0A%0A---------------------------------------%0A%0A*" +
            this.nomecompleto +
            "*%0A" +
            this.telefone +
            "%0A%0A---------------------------------------%0A%0A*" +
            this.tipo +
            "%20no%20local*%0A%0A---------------------------------------%0A%0A*" +
            this.msgRetirada +
            "*";
        } else {
          this.tipo = "Entrega";

          linkWpp =
            "https://api.whatsapp.com/send?phone=" +
            this.msgBuscaFone +
            "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
            this.buscacodigo(this.vendaspedidos) +
            "*%0A---------------------------------------%0A%0A" +
            this.whatsapp(this.products) +
            "%0A*Produtos:%20R$%20" +
            this.total.toFixed(2) +
            "*%0A" +
            "%0A*Taxa de entrega:%20R$%20" +
            parseFloat(this.taxa).toFixed(2) +
            "*%0A" +
            "%0A*Total:%20R$%20" +
            (parseFloat(this.total) + parseFloat(this.taxa)).toFixed(2) +
            "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
            this.buscaTroco +
            "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
            this.pagamento +
            "%0A%0A---------------------------------------%0A%0A*" +
            this.nomecompleto +
            "*%0A" +
            this.telefone +
            "%0A%0A---------------------------------------%0A%0A*" +
            this.tipo +
            "*%0A*Cidade:*%20" +
            this.cidade +
            "%0A*Estado:*%20" +
            this.estado +
            "%0A*Bairro:*%20" +
            this.bairro +
            "%0A*Rua:*%20" +
            this.rua +
            "%0A*Complemento:*%20" +
            this.complemento +
            "%0A*Referência:*%20" +
            this.referencia +
            "%0A%0A---------------------------------------%0A%0A*" +
            this.msgEntrega +
            "*";
        }

        if (this.pagamento === "pix-online") {
          this.$store.commit("setPagamentoPix", {
            id: responsePix.data.id,
            date: responsePix.data.expira,
            payload: responsePix.data.chave,
            valor: responsePix.data.total,
            linkWpp: linkWpp,
          });
          this.$store.commit("setZera", []);
          this.$router.push("/pagamentopix");
        } else {
          Swal.fire({
            title: "Pedido realizado com sucesso!",
            text: "Seu pedido foi realizado e aprovado com sucesso.",
            confirmButtonColor: "#000000",
          });

          var win = window.open(linkWpp, "_blank");

          if (win == null || win == undefined) {
            window.location.assign(linkWpp);
          }

          this.$store.commit("setZera", []);
          this.$router.push("/");
        }
      } catch (err) {
        console.log(err);
        this.isDisabled = false;
        this.showTelaCarregamento(false);
      }
    },
    async validarCampos() {
      console.log("2campo retirar", this.endereco_cd);
      const campos = [
        {
          condicao: this.taxa === "",
          mensagem: "Por favor, selecione o seu endereço.",
        },
        {
          condicao:
            this.endereco_cd !== "comerLocal" &&
            this.endereco_cd !== "retirarLocal" &&
            this.endereco_cd === "",
          mensagem: "Por favor, selecione uma forma de entrega.",
        },
        {
          condicao:
            this.enderecos === null &&
            this.endereco_cd !== "comerLocal" &&
            this.endereco_cd !== "retirarLocal",
          mensagem: "Por favor, selecione uma forma de entrega.",
        },
        {
          condicao: this.pagamento === "",
          mensagem: "Por favor, selecione forma de pagamento.",
        },
        {
          condicao: this.pagamento === "dinheiro" && this.valorDinheiro === "",
          mensagem: "Por favor, digite valor em dinheiro.",
        },
      ];

      // Verifica cada campo e exibe a mensagem apropriada se necessário
      for (const { condicao, mensagem } of campos) {
        if (condicao) {
          await Swal.fire({
            title: mensagem,
            confirmButtonColor: "#000000",
          });
          return false;
        }
      }

      // Se todos os campos forem válidos, retorne true
      return true;
    },
    async validarCamposValor(v) {
      // Defina todos os campos e suas respectivas mensagens de erro
      console.log("1campo retirar", this.endereco_cd);
      console.log("1campo checkedAgendamento", this.checkedAgendamento);

      const dataSelecionada = new Date(this.dataAgendamento);
      const dataMinima = new Date(this.DateMinTime);

      const dataMinimaFormatada = this.DateMinTime.replace("T", " ");

      const campos = [
        {
          condicao: this.taxa === "",
          mensagem: "Por favor, selecione o seu endereço.",
        },
        {
          condicao:
            this.endereco_cd !== "comerLocal" &&
            this.endereco_cd !== "retirarLocal" &&
            this.endereco_cd === "",
          mensagem: "Por favor, selecione uma forma de entrega.",
        },
        {
          condicao:
            this.enderecos === null &&
            this.endereco_cd !== "comerLocal" &&
            this.endereco_cd !== "retirarLocal",
          mensagem: "Por favor, selecione uma forma de entrega.",
        },
        {
          condicao: this.pagamento === "",
          mensagem: "Por favor, selecione forma de pagamento.",
        },
        {
          condicao: this.pagamento === "dinheiro" && this.valorDinheiro === "",
          mensagem: "Por favor, digite valor em dinheiro.",
        },
        {
          condicao: v.total === "0.00",
          mensagem: "Por favor, selecione um produto.",
        },
        {
          condicao: parseFloat(this.valorMinimo) > parseFloat(v.total),
          mensagem: `O valor mínimo de compra é: ${this.valorMinimo} reais`,
        },
        {
          condicao: this.somenteAgendamento == "1" && 
          this.checkedAgendamento.length <= 0,
          mensagem: "No momento só aceitamos agendamento de pedidos" 
        },
        {
          condicao:
            dataSelecionada < dataMinima &&
            this.cdAgendamento == "1" &&
            this.checkedAgendamento.length > 0,
          mensagem: `Data deve ser maior que ${this.DateMinTime.replace(
            "T",
            " "
          )}`,
        },
      ];

      // Verifica cada campo e exibe a mensagem apropriada se necessário
      for (const { condicao, mensagem } of campos) {
        if (condicao) {
          await Swal.fire({
            title: mensagem,
            confirmButtonColor: "#000000",
          });
          return false;
        }
      }

      // Se todos os campos forem válidos, retorne true
      return true;
    },
    validarNumeroCartao(cardNumber) {
      if (!cardNumber) return false;
      if (!/^\d{15,16}$/.test(cardNumber)) return false;

      var nCheck = 0,
        nDigit = 0,
        bEven = false;
      cardNumber = cardNumber.replace(/\D/g, "");

      for (var n = cardNumber.length - 1; n >= 0; n--) {
        var cDigit = cardNumber.charAt(n),
          nDigit = parseInt(cDigit, 10);

        if (bEven) {
          if ((nDigit *= 2) > 9) nDigit -= 9;
        }

        nCheck += nDigit;
        bEven = !bEven;
      }

      return nCheck % 10 == 0;
    },
    validarBandeiraCartao(cardNumber) {
      if (!cardNumber) return false;
      const bandeira = creditCardType(cardNumber)[0].type;
      if (
        !["visa", "mastercard", "elo", "discover", "american-express"].includes(
          bandeira
        )
      )
        return false;
      return true;
    },
    validarCvvCartao(cardNumber, cvv) {
      if (!cardNumber || !cvv) return false;
      if (!/^\d+$/.test(cvv)) return false;

      const bandeira = creditCardType(cardNumber)[0].type;

      if (bandeira === "american-express")
        if (cvv.length !== 4) return false;
        else if (cvv.length !== 3) return false;

      return true;
    },
    async validarCamposCartao(cartao) {
      const dadosCartao = [
        {
          condicao: cartao.cardInfo.holderName === "",
          mensagem: "Digite o nome do títular do cartão",
        },
        {
          condicao: cartao.cardInfo.holderName.length > 60,
          mensagem: "O nome do títular só pode até 60 letras",
        },
        {
          condicao: cartao.cardInfo.number === "",
          mensagem: "Digite o número do cartão",
        },
        {
          condicao: !this.validarNumeroCartao(cartao.cardInfo.number),
          mensagem: "O número do cartão digitado é inválido",
        },
        {
          condicao: !this.validarBandeiraCartao(cartao.cardInfo.number),
          mensagem: "Não aceitamos a bandeira do seu cartão",
        },
        {
          condicao: cartao.cardInfo.expiryDate === "",
          mensagem: "A data de expiração está inválida",
        },
        {
          condicao: !/^(0?[1-9]|1[0-2])$/.test(
            cartao.cardInfo.expiryDate.split("/")[0]
          ),
          mensagem: "A data de expiração está inválida",
        },
        {
          condicao:
            !/^(202[5-9]|20[3-9][0-9]|2[1-9][0-9]{2}|[3-9][0-9]{3}|2[5-9]|[3-9][0-9])$/.test(
              cartao.cardInfo.expiryDate.split("/")[1]
            ),
          mensagem: "A data de expiração está inválida",
        },
        {
          condicao: cartao.cardInfo.cvv === "",
          mensagem: "Digite o CVV do cartão",
        },
        {
          condicao: !this.validarCvvCartao(
            cartao.cardInfo.number,
            cartao.cardInfo.cvv
          ),
          mensagem: "O CVV do cartão é inválido",
        },
      ];

      const dadosUsuario = [
        {
          condicao: cartao.cardHolderInfo.name === "",
          mensagem: "Digite o nome do títular do cartão",
        },
        {
          condicao: cartao.cardHolderInfo.name.length > 60,
          mensagem: "O nome do títular só pode até 60 letras",
        },
        {
          condicao: cartao.cardHolderInfo.email === "",
          mensagem: "Digite o email do títular",
        },
        {
          condicao:
            !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
              cartao.cardHolderInfo.email
            ),
          mensagem: "O email do títular é inválido",
        },
        {
          condicao: cartao.cardHolderInfo.cpfCnpj === "",
          mensagem: "Digite o CPF do títular",
        },
        {
          condicao: !this.validarCPF(cartao.cardHolderInfo.cpfCnpj),
          mensagem: "O CPF do títular é inválido",
        },
        {
          condicao: cartao.cardHolderInfo.phone === "",
          mensagem: "Digite o telefone do títular",
        },
        {
          condicao: !/^\d{2}(9\d{8}|\d{8})$/.test(cartao.cardHolderInfo.phone),
          mensagem: "O telefone do títular é inválido",
        },
      ];

      const dadosEndereco = [
        {
          condicao: cartao.cardHolderInfo.postalCode === "",
          mensagem: "Digite o CEP do endereço",
        },
        {
          condicao: !/^\d{8}$/.test(cartao.cardHolderInfo.postalCode),
          mensagem: "O CEP do endereço é inválido",
        },
        {
          condicao: cartao.cardHolderInfo.addressNumber === "",
          mensagem: "Digite o número do endereço",
        },
        {
          condicao: !/^\d{1,5}$/.test(cartao.cardHolderInfo.addressNumber),
          mensagem: "O número do endereço é inválido",
        },
        {
          condicao:
            cartao.cardHolderInfo.addressComplement !== "" &&
            !/^.{1,100}$/.test(cartao.cardHolderInfo.addressComplement),
          mensagem: "O complemento só pode ser até 60 caracteres",
        },
      ];

      const array = [
        ...dadosCartao,
        ...(cartao.cardHolderInfo.sameAsUser === "0" ? dadosUsuario : []),
        ...(!cartao.cardHolderInfo.idAddress ? dadosEndereco : []),
      ];

      for (const { condicao, mensagem } of array) {
        if (condicao) {
          await Swal.fire({
            title: mensagem,
          });
          return false;
        }
      }

      return true;
    },
    async InisHorarioAgendar() {
      this.tempoMininoAgendar = 0;
      try {
        const resposta = await Inis.listarInisCd("HORARIO_AGENDAR");
        if (
          resposta &&
          resposta.data &&
          resposta.data.length > 0 &&
          resposta.data[0].vl !== undefined
        ) {
          this.tempoMininoAgendar = parseInt(resposta.data[0].vl, 10);
        } else {
        }
      } catch (erro) {
        this.tempoMininoAgendar = 0;
      }
    },
    async setDate() {
      const currentDate = new Date();
      await this.InisHorarioAgendar();

      const milissegundosAdicionais = this.tempoMininoAgendar * 60 * 60 * 1000;
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const dataMinimaComHorasExtras = new Date(
        currentDate.getTime() + milissegundosAdicionais
      );

      const minYear = dataMinimaComHorasExtras.getFullYear();
      const minMonth = String(dataMinimaComHorasExtras.getMonth() + 1).padStart(
        2,
        "0"
      );
      const minDay = String(dataMinimaComHorasExtras.getDate()).padStart(
        2,
        "0"
      );
      const minHours = String(dataMinimaComHorasExtras.getHours()).padStart(
        2,
        "0"
      );
      const minMinutes = String(dataMinimaComHorasExtras.getMinutes()).padStart(
        2,
        "0"
      );

      console.log("horario min", this.tempoMininoAgendar);

      this.dataAgendamento = `${year}-${month}-${day}T${hours}:${minutes}`;
      this.minDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
      this.DateMinTime = `${minYear}-${minMonth}-${minDay}T${minHours}:${minMinutes}`;
    },
    validateSelectedTime() {
      const currentTimeInt = Date.now();

      var selectedTime = JSON.parse(JSON.stringify(this.dataAgendamento));

      const selectedTimeInt = new Date(selectedTime).getTime();

      if (currentTimeInt > selectedTimeInt) {
        return false;
      }
      return true;
    },
  },
  watch: {
    cartao: {
      handler(valor) {
        const valorAntigo = this.cartaoAnterior;

        if (
          !/^\d{1,2}$/g.test(valor.cardInfo.expiryMonth) &&
          valor.cardInfo.expiryMonth !== ""
        ) {
          this.cartao.cardInfo.expiryMonth =
            valorAntigo?.cardInfo.expiryMonth || "";
        }

        if (
          !/^\d{1,4}$/g.test(valor.cardInfo.expiryYear) &&
          valor.cardInfo.expiryYear !== ""
        ) {
          this.cartao.cardInfo.expiryYear =
            valorAntigo?.cardInfo.expiryYear || "";
        }

        this.cartaoAnterior = JSON.parse(JSON.stringify(valor));
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    if (this.logado == false) {
      this.$router.push("/login");
    }
  },
  async mounted() {
    try {
      this.verficarAgendamentoProdutos();
      this.setDate();
      this.listandoInisEstoque();
      this.listarBandeiras();
      this.listarInisValorMinimo();
      await this.listarinis();
      this.listarinisvalores();
      this.buscafone();
      this.buscacodigo();
      this.buscaretirada();
      this.buscaentrega();
      this.listarpedidosvenda();
      this.listandoInisRetirarLocal();
      this.listandoInisSomenteRetirada();
      this.email = localStorage.getItem(
        "email" + localStorage.getItem("contrato")
      );
      this.cel = localStorage.getItem(
        "telefone" + localStorage.getItem("contrato")
      );
      await this.listandoEnderecos();
    } catch (err) {
      console.error(err);
    }
  },
};
</script>
